import React, { useState } from 'react';
import { Button, Dialog, Link, MessagePlugin, Popconfirm, Table } from 'tdesign-react';
import PermWrapper from '@/components/PermWrapper';
import { deletePackageByVersion } from '@/services/functionService';
import { renderDateTime } from '@/utils/common';
import ModalHeader from '@/components/Header/Modal';
import ModalForm from '../ModalForm';

export default function PackageTable({ clusterName, doRefresh, row, options, packageOptions }) {
  const [visible, setVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  const columns = [
    {
      width: 85,
      title: '版本',
      colKey: 'version',
    },
    {
      title: '备注',
      colKey: 'note',
    },
    {
      width: 180,
      title: '上传时间',
      colKey: 'createTime',
      cell: renderDateTime,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row }) => (
        <PermWrapper resource='pulsar:function:packageManage:delete'>
          <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
            <Link theme='danger' hover='color'>
              删除
            </Link>
          </Popconfirm>
        </PermWrapper>
      ),
      width: 150,
    },
  ];

  const doDelete = async (row) => {
    try {
      await deletePackageByVersion({
        clusterName,
        packageName: row.packageName,
        packageType: row.packageType,
        packageVersion: row.version,
        functionRuntime: row.functionRuntime,
      });
      MessagePlugin.success('删除成功');
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    }
  };

  const handleClose = (fresh) => {
    setFormVisible(false);
    if (fresh) {
      doRefresh();
    }
  };

  return (
    <>
      <Link theme='primary' onClick={() => setVisible(true)} hover='color'>
        版本
      </Link>
      <Dialog
        header={
          <ModalHeader
            tags={[row.packageName, row.packageType, row.functionRuntime]}
            tail={<Button onClick={() => setFormVisible(true)}>新增版本</Button>}
          >
            版本管理
          </ModalHeader>
        }
        visible={visible}
        width={800}
        destroyOnClose
        onClose={() => {
          setVisible(false);
        }}
        footer={null}
      >
        <Table columns={columns} data={row.versions} rowKey='version' pagination={false} />
        <ModalForm
          visible={formVisible}
          options={options}
          packageOptions={packageOptions}
          handleClose={handleClose}
          row={row}
        />
      </Dialog>
    </>
  );
}
